<template>
  <div class="fixed inset-x-0 bottom-0 z-[9999]">
    <div
      class="flex w-full cursor-pointer items-center justify-center px-[20px] pt-[24px] backdrop-blur-sm"
      :class="{ 'bg-[#3C3A36CC]': !isLightMode, 'bg-[#F6F4F099]': isLightMode }"
      :style="containerStyle"
      @click="register()"
    >
      <div
        class="flex h-12 w-full items-center justify-center rounded-[100px] border bg-[#FEC629] text-center text-[1rem] font-bold text-black shadow-[0_2px_6px_rgba(33,32,30,0.18)]"
        :class="isLightMode ? 'border-[#21201E]' : 'border-[#ECEBEB]'"
      >
        <div>{{ label }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { openUrl } from '@/utils/browser-helper';
import { trackEventRegisterClicked } from '@/utils/analytics';

export default {
  name: 'RegisterButton',
  computed: {
    ...mapState('eventPage', ['isLightMode']),
    containerStyle() {
      return {
        minHeight: '120px',
        paddingBottom: 'max(48px, env(safe-area-inset-bottom, 0px))',
      };
    },
  },
  props: {
    label: {
      type: String,
      default: 'Register now',
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
    registrationUrl: {
      type: String,
      default: '',
    },
    eventId: {
      type: [String, Number],
      default: '',
    },
    eventSlug: {
      type: String,
      default: '',
    },
    eventTitle: {
      type: String,
      default: '',
    },
  },
  methods: {
    async register() {
      trackEventRegisterClicked({
        eventId: this.eventId,
        slug: this.eventSlug,
        title: this.eventTitle,
        destination: this.registrationUrl,
        source: 'event-page-register',
      });
      if (this.isExternal) {
        await openUrl(
          {
            url: this.registrationUrl,
          },
          {
            title: 'Event Registration',
            source: 'event-register',
            page: 'EventPage',
          },
        );
      } else {
        // trim away everything before /forms in the registrationUrl
        const url = this.registrationUrl.substring(this.registrationUrl.indexOf('/forms'));
        this.$router.push(url);
      }
    },
  },
};
</script>
